var Plotly = require('plotly.js/lib/core');

Plotly.register([
    require('plotly.js/lib/bar'),
]);

module.exports = Plotly;



//////////////////
// WEBPACK FOOTER
// ./src/misc/external/plotly.js
// module id = oMy5
// module chunks = 1